import VueAnalytics from 'vue-analytics';
import Vue from 'vue';
import router from '@/router';

var isProd = process.env.NODE_ENV == 'production';

Vue.use(VueAnalytics, {
  id: [process.env.VUE_APP_GA_TRACKING_ID],
  router,
  debug: {
    enabled: false, // disabled by default unless a developer wants it
    sendHitTask: isProd,
  },
});
